import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { base_url } from '../utils/GlobalVariables';
import Swal from "sweetalert2";
import { CustomDescrypt, CustomEncrypt } from '../utils/MyEncryption'
import { AuthStore } from '../store/UserStore';
import { Box, Card, CardContent, Container, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import login from '../assets/images/login.svg'
import LoadingButton from '@mui/lab/LoadingButton';
import logo_buton from '../assets/images/logo-buton.png'

function Login() {
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        "username": '',
        "pswd": '',
        "tahun": ""
    });
    const { user, setUser } = AuthStore((state) => ({ user: state.user, setUser: state.setUser }));
    const userData = localStorage.getItem('AuthPersist');
    const [tahun, setTahun] = React.useState('');

    const handleSelectTahun = (e) => {
        setTahun(e.target.value);
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        // console.log(formData);
    };

    useEffect(() => {
        if (userData !== null) {
            const xx = JSON.parse(userData);
            // console.log(xx.state.user);

            
            if (xx.state.user !== null) {
                const decryptedUser = JSON.parse(CustomDescrypt(xx.state.user));
                // console.log(decryptedUser.role);

                if (decryptedUser.role === 'Bendahara') {
                    navigate("/bnd", { replace: true });
                }
                else if (decryptedUser.role === 'Ppk') {
                    navigate("/ppk", { replace: true });
                }
                else if (decryptedUser.role === 'Verifikator') {
                    navigate("/verif", { replace: true });
                }
                else if (decryptedUser.role === 'Admin') {
                    navigate("/admin", { replace: true });
                }
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
        // console.log(formData);
    }

    const submitForm = (e) => {
        e.preventDefault()
        if (formData.tahun === "" || formData.pswd === "" || formData.username === "") {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: "Isi semua input"
            })
            return
        }
        setLoading(true);
        axios.post(base_url + '/auth', formData)
            .then(function (response) {
                if (response.status === 200) {
                    let data = response.data;
                    let encrypted = CustomEncrypt(JSON.stringify(data));
                    setUser(encrypted);
                }
                // console.log(response);
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                if (error.response.status === 400) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.message
                    })
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + " " + error.response.statusText
                    })
                }
                setLoading(false);
            });
    }

    return (
        <Container>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Grid container justify="flex-start" height={'100vh'}>
                    <Grid
                        item
                        md={8}
                        xs={12}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}>
                        <img
                            width={'100%'}
                            height={'100%'}
                            src={login}
                            srcSet={login}
                            alt="bfjsdhhj"
                            loading="lazy"
                        />
                    </Grid>
                    <Grid
                        // width={{ md: '100%', xs: '50%' }}
                        item
                        md={4}
                        xs={12}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            textAlign: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Container xs={8}>
                            <Card xs={8}>
                                <CardContent>
                                    <img
                                        width={'50%'}
                                        height={'100%'}
                                        src={logo_buton}
                                        srcSet={logo_buton}
                                        alt="bfjsdhhj"
                                        loading="lazy"
                                    />
                                    <Typography
                                        variant="h5"
                                        component="div"
                                        sx={{
                                            mb: '2rem',
                                            mt: '2rem'
                                        }}
                                    >
                                        Login terlebih dahulu
                                    </Typography>
                                    <form
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Grid>
                                            <TextField
                                                required
                                                id="username"
                                                label="Username"
                                                variant="standard"
                                                fullWidth
                                                margin="normal"
                                                name='username'
                                                onChange={onChangeInput}
                                            />
                                            <TextField
                                                required
                                                id="password"
                                                label="Password"
                                                variant="standard"
                                                fullWidth
                                                margin="normal"
                                                type="password"
                                                name='pswd'
                                                onChange={onChangeInput}
                                            />
                                            <FormControl variant="standard" sx={{ mb: 3, textAlign:'left' }} fullWidth>
                                                <InputLabel id="demo-simple-select-standard-label">Tahun</InputLabel>
                                                <Select
                                                required={true}
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={tahun}
                                                    onChange={handleSelectTahun}
                                                    label="Age"
                                                    name="tahun"
                                                >
                                                    {/* <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem> */}
                                                    <MenuItem value={(new Date().getFullYear())}>{(new Date().getFullYear())}</MenuItem>
                                                    <MenuItem value={(new Date().getFullYear()) - 1}>{(new Date().getFullYear()) - 1}</MenuItem>
                                                    <MenuItem value={(new Date().getFullYear()) - 2}>{(new Date().getFullYear()) - 2}</MenuItem>
                                                    <MenuItem value={(new Date().getFullYear()) - 3}>{(new Date().getFullYear()) - 3}</MenuItem>
                                                    <MenuItem value={(new Date().getFullYear()) - 4}>{(new Date().getFullYear()) - 4}</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <LoadingButton
                                                onClick={submitForm}
                                                loading={loading}
                                                variant="outlined"
                                                margin="normal"
                                                type="submit"
                                            >
                                                Login
                                            </LoadingButton>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>
                        </Container>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}

export default Login